export default __webpack_public_path__ + "static/production-3-e83d60b025948f700dd2e978a5f1f365.png";